import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { ArrowRightIcon, HeartIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-1896">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-1897">
        <SparkleEffect count={80} data-id="element-1898" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-1899">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-1900">
            Trippin' Through <span className="text-cta-500" data-id="element-1901">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-1902">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* SPARKLY QUOTE MARQUEE */}
      <SplitFlapQuote data-id="element-1903" />

      {/* REDESIGNED CRISIS SECTION */}
      <section className="py-16 bg-gradient-to-br from-lavender-50 via-blush-50 to-pink-50 relative overflow-hidden" data-id="element-1904">
        <SparkleEffect count={40} data-id="element-1905" />

        {/* Decorative blurred circles for soft glow */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-1906" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-1907" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1908">
          <div className="text-center mb-12" data-id="element-1909">
            <GlitterHeart size={40} variant="light" className="mx-auto mb-4" data-id="element-1910" />
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-plum-700 mb-3" data-id="element-1911">
              If You're Not Okay Right Now
            </h2>
            <p className="text-plum-600 text-lg font-medium max-w-2xl mx-auto" data-id="element-1912">
              You're not alone. You don't have to go through this by yourself.
            </p>
          </div>

          {/* IMMEDIATE CRISIS HELP */}
          <div className="mb-12" data-id="element-1913">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1914">
              <span className="text-2xl" data-id="element-1915">🚨</span> Immediate Crisis Help
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1916">
              {/* Card 1: Lifeline */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1917">
                <div className="flex items-center gap-3 mb-4" data-id="element-1918">
                  <div className="w-10 h-10 rounded-full bg-sky-50 flex items-center justify-center shrink-0" data-id="element-1919">
                    <PhoneIcon className="w-5 h-5 text-sky-500" data-id="element-1920" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1921">
                    Suicide & Crisis Lifeline
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1922">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1923">Call or text</p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1924">
                    988
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5 mb-1" data-id="element-1925">
                    <span className="text-cta-400" data-id="element-1926">Chat:</span> 988lifeline.org
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1927">
                    <span data-id="element-1928">🕒</span> Available 24/7, free & confidential
                  </p>
                </div>
                <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-sky-50 text-sky-600 hover:bg-sky-100 font-bold transition-colors mt-auto" data-id="element-1929">
                  Get Help Now <ArrowRightIcon className="w-4 h-4" data-id="element-1930" />
                </a>
              </div>

              {/* Card 2: Text Line */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1931">
                <div className="flex items-center gap-3 mb-4" data-id="element-1932">
                  <div className="w-10 h-10 rounded-full bg-cta-50 flex items-center justify-center shrink-0" data-id="element-1933">
                    <MessageCircleIcon className="w-5 h-5 text-cta-500" data-id="element-1934" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1935">
                    Crisis Text Line
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1936">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1937">
                    Text <strong className="text-plum-800" data-id="element-1938">HOME</strong> to
                  </p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1939">
                    741741
                  </p>
                  <p className="text-plum-500 text-sm font-medium mb-1" data-id="element-1940">
                    Connects you with a trained crisis counselor
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1941">
                    <span data-id="element-1942">🕒</span> Available 24/7
                  </p>
                </div>
                <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-cta-50 text-cta-600 hover:bg-cta-100 font-bold transition-colors mt-auto" data-id="element-1943">
                  Talk to Someone <ArrowRightIcon className="w-4 h-4" data-id="element-1944" />
                </a>
              </div>

              {/* Card 3: Emergency */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1945">
                <div className="flex items-center gap-3 mb-4" data-id="element-1946">
                  <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center shrink-0" data-id="element-1947">
                    <span className="text-xl" data-id="element-1948">🚓</span>
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1949">Emergency</h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1950">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1951">Call</p>
                  <p className="text-4xl font-black text-red-500 mb-3 tracking-tight" data-id="element-1952">
                    911
                  </p>
                  <p className="text-plum-500 text-sm font-medium" data-id="element-1953">
                    If someone is in immediate danger
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SPECIALIZED SUPPORT */}
          <div className="mb-8" data-id="element-1954">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1955">
              <span className="text-2xl" data-id="element-1956">💖</span> Specialized Support
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1957">
              {/* Trevor Project */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1958">
                <div className="flex items-center gap-3 mb-3" data-id="element-1959">
                  <span className="text-2xl" data-id="element-1960">🌈</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1961">LGBTQ+ Support</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1962">
                  The Trevor Project
                </p>
                <div className="space-y-2 mb-4" data-id="element-1963">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1964">
                    1-866-488-7386
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1965">
                    Text <strong className="text-plum-800" data-id="element-1966">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-1967">678678</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1968">
                    <span data-id="element-1969">🕒</span> 24/7 support for LGBTQ+ youth
                  </p>
                </div>
                <a href="https://www.thetrevorproject.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1970">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-1971" />
                </a>
              </div>

              {/* SAMHSA */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1972">
                <div className="flex items-center gap-3 mb-3" data-id="element-1973">
                  <span className="text-2xl" data-id="element-1974">🧠</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1975">
                    Mental Health & Substance Use
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1976">
                  SAMHSA National Helpline
                </p>
                <div className="space-y-2" data-id="element-1977">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1978">
                    1-800-662-4357
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1979">
                    <span data-id="element-1980">🕒</span> 24/7, free, confidential
                  </p>
                </div>
              </div>

              {/* Postpartum */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1981">
                <div className="flex items-center gap-3 mb-3" data-id="element-1982">
                  <span className="text-2xl" data-id="element-1983">👩‍👧</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1984">
                    Postpartum Support
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1985">
                  For Moms (EN/ES)
                </p>
                <div className="space-y-2 mb-4" data-id="element-1986">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1987">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1988">
                    1-800-944-4773
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1989">
                    <span data-id="element-1990">🕒</span> Not 24/7, but very responsive
                  </p>
                </div>
                <a href="https://www.postpartum.net/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1991">
                  Visit Website <ArrowRightIcon className="w-3 h-3" data-id="element-1992" />
                </a>
              </div>

              {/* Domestic Violence */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1993">
                <div className="flex items-center gap-3 mb-3" data-id="element-1994">
                  <span className="text-2xl" data-id="element-1995">💔</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1996">Domestic Violence</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1997">
                  National Hotline
                </p>
                <div className="space-y-2 mb-4" data-id="element-1998">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1999">
                    1-800-799-7233
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-2000">
                    Text <strong className="text-plum-800" data-id="element-2001">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-2002">88788</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2003">
                    <span data-id="element-2004">🕒</span> 24/7
                  </p>
                </div>
                <a href="https://www.thehotline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-2005">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-2006" />
                </a>
              </div>

              {/* Child Abuse */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-2007">
                <div className="flex items-center gap-3 mb-3" data-id="element-2008">
                  <span className="text-2xl" data-id="element-2009">👶</span>
                  <h4 className="font-bold text-plum-800" data-id="element-2010">
                    Child Abuse Hotline
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-2011">
                  Childhelp
                </p>
                <div className="space-y-2" data-id="element-2012">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-2013">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-2014">
                    1-800-422-4453
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2015">
                    <span data-id="element-2016">🕒</span> 24/7
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-plum-500 font-medium italic mt-12" data-id="element-2017">
            Take a breath. You're going to be okay. 💗
          </p>
        </div>
      </section>

      {/* SECOND MARQUEE - extra positivity */}
      <SplitFlapQuote data-id="element-2018" />

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-2019">
        <SparkleEffect count={60} data-id="element-2020" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2021">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2022">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-2023">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-2024">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-2025">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          {/* Free Coaching Call - thin wide card above the grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-10" data-id="element-2026">
            <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-gradient-to-r from-cta-50 to-pink-50 rounded-2xl px-8 py-5 border-2 border-cta-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all" data-id="element-2027">
              <div className="flex items-center gap-4" data-id="element-2028">
                <span className="text-3xl" data-id="element-2029">💗</span>
                <div data-id="element-2030">
                  <h3 className="font-heading text-lg font-bold text-plum-800" data-id="element-2031">
                    Need Someone to Talk To?
                  </h3>
                  <p className="text-plum-500 font-medium text-sm" data-id="element-2032">
                    Book a free coaching call — no strings, no judgment, just
                    support.
                  </p>
                </div>
              </div>
              <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 shrink-0" data-id="element-2033">
                Book a Free Call
                <ArrowRightIcon className="w-4 h-4" data-id="element-2034" />
              </span>
            </a>
          </motion.div>

          {/* GRID ROW 1 */}
          <div id="free-lists" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8 scroll-mt-32" data-id="element-2035">
            {/* Interactive Cleaning Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cta-50 to-white rounded-3xl p-8 border-2 border-cta-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2036">
              <div className="absolute top-4 right-4 bg-cta-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2037">
                NEW ✨
              </div>
              <div className="text-3xl mb-4" data-id="element-2038">✨</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-2039">
                Free Interactive Cleaning Schedule
              </h3>
              <p className="text-plum-600 font-medium mb-8 flex-grow" data-id="element-2040">
                The Ultimate Cleaning Schedule — what to clean & when. Check
                things off, track your progress, use it every week for free!
              </p>
              <Link to="/free-resources/cleaning-schedule" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 w-full" data-id="element-2041">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-2042" />
              </Link>
            </motion.div>

            {/* Interactive Self-Care Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-gradient-to-br from-pink-50 to-white rounded-3xl p-8 border-2 border-pink-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2043">
              <div className="absolute top-4 right-4 bg-pink-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2044">
                NEW 🧖‍♀️
              </div>
              <div className="text-3xl mb-4" data-id="element-2045">🧖‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-pink-800 mb-4" data-id="element-2046">
                Free Interactive Self-Care Checklist
              </h3>
              <p className="text-pink-600 font-medium mb-8 flex-grow" data-id="element-2047">
                Daily hygiene and wellness ritual. Take care of your body and
                mind with this simple, trackable daily routine!
              </p>
              <Link to="/free-resources/self-care/daily" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-pink-500 text-white font-bold text-sm hover:bg-pink-600 transition-colors shadow-lg shadow-pink-500/20 w-full" data-id="element-2048">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-2049" />
              </Link>
            </motion.div>

            {/* Free Pre-Trip Home Prep Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 border-2 border-emerald-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2050">
              <div className="absolute top-4 right-4 bg-emerald-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2051">
                NEW 🏡
              </div>
              <div className="text-3xl mb-4" data-id="element-2052">🏡</div>
              <h3 className="font-heading text-2xl font-bold text-emerald-800 mb-4" data-id="element-2053">
                Free Pre-Trip Home Prep Checklist
              </h3>
              <p className="text-emerald-600 font-medium mb-8 flex-grow" data-id="element-2054">
                What to do before you leave so you come back to a peaceful,
                clean home. 10 sections covering everything from kitchen prep to
                security!
              </p>
              <Link to="/free-resources/travel/home-prep" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-emerald-500 text-white font-bold text-sm hover:bg-emerald-600 transition-colors shadow-lg shadow-emerald-500/20 w-full" data-id="element-2055">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-2056" />
              </Link>
            </motion.div>

            {/* FREE WORKOUT CONSULTATION Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-gradient-to-br from-sky-50 to-lavender-50 rounded-3xl p-8 border-2 border-sky-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2057">
              <div className="absolute top-4 right-4 bg-sky-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2058">
                FREE 💪
              </div>
              <div className="text-3xl mb-4" data-id="element-2059">💪</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-2060">
                Free Workout Consultation
              </h3>
              <p className="text-plum-600 font-medium mb-3 flex-grow" data-id="element-2061">
                Meet Jake — once the smallest in the room, now lifting over 500
                lbs and training for championship-level competition. His journey
                is proof of what consistency and discipline can do.
              </p>
              <p className="text-plum-500 text-sm font-medium mb-6" data-id="element-2062">
                Free consultations, zero pressure — just real advice from
                someone who's been exactly where you are.
              </p>
              <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-sky-500 text-white font-bold text-sm hover:bg-sky-600 transition-colors shadow-lg shadow-sky-500/20 w-full" data-id="element-2063">
                Book Free Consultation
                <ArrowRightIcon className="w-4 h-4" data-id="element-2064" />
              </a>
            </motion.div>
          </div>

          {/* PANIC ATTACK GROUNDING - Full width between rows */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-blush-50 to-lavender-50 rounded-3xl p-8 md:p-10 shadow-lg border border-blush-100 my-12" data-id="element-2065">
            <div className="text-center mb-6" data-id="element-2066">
              <div className="text-4xl mb-3" data-id="element-2067">🫧</div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-plum-700 mb-2" data-id="element-2068">
                Struggling with a Panic Attack?
              </h2>
              <p className="text-plum-500 font-semibold" data-id="element-2069">
                If you're having anxiety or a panic attack, try this grounding
                technique:
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-2070">
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-2071">
                <span className="text-3xl block mb-3" data-id="element-2072">👀</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-2073">
                  See 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-2074">
                  Look around and name 5 things you can see right now.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-2075">
                <span className="text-3xl block mb-3" data-id="element-2076">✋</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-2077">
                  Feel 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-2078">
                  Touch 5 different textures — your shirt, the table, your hair.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-2079">
                <span className="text-3xl block mb-3" data-id="element-2080">👂</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-2081">
                  Hear 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-2082">
                  Close your eyes and listen for 5 sounds around you.
                </p>
              </div>
            </div>
            <p className="text-cta-500 font-bold text-center mt-6 text-sm italic" data-id="element-2083">
              This helps bring your mind back to the present moment. You're
              going to be okay. 💗
            </p>
          </motion.div>

          {/* GRID ROW 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-2084">
            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-2085">
              <div className="text-3xl mb-4" data-id="element-2086">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-2087">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-2088">
                <li className="flex items-start gap-2" data-id="element-2089">
                  <span className="text-cta-500 mt-1" data-id="element-2090">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-2091">
                  <span className="text-cta-500 mt-1" data-id="element-2092">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-2093">
                  <span className="text-cta-500 mt-1" data-id="element-2094">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-2095">
                  <span className="text-cta-500 mt-1" data-id="element-2096">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-2097">
                  <span className="text-cta-500 mt-1" data-id="element-2098">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-2099">
              <div className="text-3xl mb-4" data-id="element-2100">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-2101">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-2102">
                <li className="flex items-start gap-2" data-id="element-2103">
                  <span className="text-cta-500 mt-1" data-id="element-2104">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-2105">
                  <span className="text-cta-500 mt-1" data-id="element-2106">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-2107">
                  <span className="text-cta-500 mt-1" data-id="element-2108">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-2109">
              <div className="text-3xl mb-4" data-id="element-2110">🎧</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-2111">
                My Go-To Distractions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-2112">
                <li className="flex items-start gap-2" data-id="element-2113">
                  <span className="text-cta-500 mt-1" data-id="element-2114">•</span> A comfort show
                  (Gilmore Girls, anyone?)
                </li>
                <li className="flex items-start gap-2" data-id="element-2115">
                  <span className="text-cta-500 mt-1" data-id="element-2116">•</span> A podcast that
                  feels like talking to a friend
                </li>
                <li className="flex items-start gap-2" data-id="element-2117">
                  <span className="text-cta-500 mt-1" data-id="element-2118">•</span> Scrolling through
                  travel TikToks
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}